<template>
    <div :class="`${mode}`">
        <div class="h-100 position-relative pb-5 page">
            <div
                v-if="page.background_image_desktop"
                class="bg-image d-md-none"
                :style="{
                    backgroundImage: `url(${page.background_image_mobile})`
                }"
            ></div>
            <div
                v-if="page.background_image_mobile"
                class="bg-image d-none d-md-block"
                :style="{
                    backgroundImage: `url(${page.background_image_desktop})`
                }"
            ></div>
            <div id="fade"></div>
            <v-flex
                id="header"
                class="px-3"
                align="center"
                :justify="mode == 'attribution-club' ? 'center' : 'between'"
            >
                <img
                    :src="page.image_1_desktop"
                    v-if="page.image_1_desktop"
                    class="mr-1 header-image d-none d-md-inline"
                />
                <i class="d-none d-md-inline">
                    {{ page.text_1_desktop || page.text_1_mobile }}</i
                >
                <img
                    :src="page.image_1_mobile"
                    v-if="page.image_1_mobile"
                    class=" d-md-none mr-1 header-image"
                />
                <i class="d-md-none"> {{ page.text_1_mobile }}</i>
            </v-flex>
            <div id="hero">
                <v-flex class="hero-content mx-auto" direction="column">
                    <v-flex direction="column">
                        <h1 id="logo">
                            <Wordmark
                                class="text-white"
                                v-if="!page.image_2_desktop"
                            />
                            <img v-else :src="page.image_2_desktop" />
                        </h1>
                        <h4 class="d-none d-md-block">
                            {{ page.text_2_desktop || page.text_2_mobile }}
                        </h4>
                        <h4 class="d-md-none">
                            {{ page.text_2_mobile }}
                        </h4>
                        <h1 class="d-none d-md-block">
                            {{ page.text_3_desktop || page.text_3_mobile }}
                        </h1>
                        <h1 class="d-md-none">
                            {{ page.text_3_mobile }}
                        </h1>
                        <div class="mt-4">
                            <div id="cta">
                                <router-link
                                    class="d-none d-md-block"
                                    to="checkout"
                                    >{{
                                        page.btn_text_1_desktop ||
                                            page.btn_text_1_mobile
                                    }}</router-link
                                >
                                <router-link class="d-md-none" to="checkout">{{
                                    page.btn_text_1_mobile
                                }}</router-link>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex id="value-props">
                        <div id="phone" class="flex-shrink-0">
                            <img
                                v-if="valueProp == 0"
                                src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Workout.png"
                            />
                            <img
                                v-if="valueProp == 1"
                                src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Home-Screen.png"
                            />
                            <img
                                v-if="valueProp == 2"
                                src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Chat.png"
                            />
                        </div>
                        <div id="carousel" class="flex-grow-1">
                            <div class="tabs">
                                <div
                                    @click="valueProp = 0"
                                    :class="{ selected: valueProp == 0 }"
                                >
                                    <img
                                        src="/img/attribution/icons/inactive/ICON_personalizedProgramming_Inactive@3x.png"
                                    />
                                    <img
                                        src="/img/attribution/icons/active/ICON_personalizedProgramming_Active@3x.png"
                                    />
                                    <div class="mt-3">
                                        Personalized<br />
                                        <b>Programming</b>
                                    </div>
                                </div>
                                <div
                                    @click="valueProp = 1"
                                    :class="{ selected: valueProp == 1 }"
                                >
                                    <img
                                        src="/img/attribution/icons/inactive/ICON_dailyIntentions_Inactive@3x.png"
                                    />
                                    <img
                                        src="/img/attribution/icons/active/ICON_dailyIntentions_Active@3x.png"
                                    />
                                    <div class="mt-3">
                                        Daily<br />
                                        <b>Intentions</b>
                                    </div>
                                </div>
                                <div
                                    @click="valueProp = 2"
                                    :class="{ selected: valueProp == 2 }"
                                >
                                    <img
                                        src="/img/attribution/icons/inactive/ICON_ongoingengagement_Inactive@3x.png"
                                    />
                                    <img
                                        src="/img/attribution/icons/active/ICON_ongoingengagement_Active@3x.png"
                                    />
                                    <div class="mt-3">
                                        Ongoing<br />
                                        <b>Engagement</b>
                                    </div>
                                </div>
                            </div>
                            <v-flex class="value" v-if="valueProp == 0">
                                <div
                                    class="mobile-screenshot d-md-none flex-shrink-0 mr-2"
                                >
                                    <img
                                        src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Workout.png"
                                    />
                                </div>
                                <div>
                                    <p>
                                        Your coach will build you a completely
                                        personalized exercise program, taking
                                        into account your ability, access and
                                        objectives.
                                    </p>
                                    <h4>YOU HAVE TO DO THE WORK</h4>
                                    <h4>
                                        YOU DON'T HAVE TO DO IT ALONE
                                    </h4>
                                </div>
                            </v-flex>

                            <v-flex class="value" v-if="valueProp == 1">
                                <div
                                    class="mobile-screenshot d-md-none flex-shrink-0 mr-2"
                                >
                                    <img
                                        src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Home-Screen.png"
                                    />
                                </div>
                                <div>
                                    <p>
                                        You and your coach will work together to
                                        mutually agree upon daily intentions and
                                        habits that build to your objectives.
                                    </p>
                                    <p>
                                        Small wins, consistently, add up to true
                                        lifestyle change.
                                    </p>
                                    <h4>SHOW UP</h4>
                                </div>
                            </v-flex>

                            <v-flex class="value" v-if="valueProp == 2">
                                <div
                                    class="mobile-screenshot d-md-none flex-shrink-0 mr-2"
                                >
                                    <img
                                        src="https://ladder-web.s3.amazonaws.com/joinladder.com/SS_Chat.png"
                                    />
                                </div>
                                <div>
                                    <p>
                                        Your coach is with you every step of the
                                        way with consistent, daily communication
                                        - available to answer questions, provide
                                        insights, and keep you motivated.
                                    </p>
                                    <h4>KEEP COACHING HUMAN</h4>
                                </div>
                            </v-flex>
                        </div>
                    </v-flex>
                </v-flex>
            </div>
        </div>
        <ladder-footer class="bg-dark" :dark="true" :powered="false">
            <template v-slot:content>
                <div class="flex-shrink-0 text-center text-dark footer-buttons">
                    <v-button
                        @click.prevent="showLegalModal = true"
                        aria-label="Ladder Legal Information"
                        class="mr-2"
                        variant="light"
                    >
                        <fa-icon :icon="['fas', 'info']" />
                    </v-button>
                    <v-button
                        @click.prevent="contactSupport"
                        aria-label="Ladder Chat Support"
                        variant="light"
                    >
                        <fa-icon :icon="['fas', 'question']" />
                    </v-button>
                </div>
            </template>
        </ladder-footer>
        <v-modal :cancel="false" :show.sync="showLegalModal">
            <div class="p-3">
                <v-button
                    aria-label="Ladder Privacy Policy"
                    block
                    class="mb-2"
                    to="/privacy"
                    variant="outline-primary"
                    >Privacy Policy</v-button
                >
                <v-button
                    aria-label="Ladder Terms of Service"
                    block
                    to="/terms"
                    variant="outline-primary"
                    >Terms of Service</v-button
                >
            </div>
        </v-modal>
    </div>
</template>

<script>
import Wordmark from "@/components/Wordmark";
import anime from "animejs/lib/anime.es.js";
import LadderFooter from "@/components/LadderFooter";
import VModal from "@/components/ui/VModal";
import store from "@/store";

export default {
    name: "AttributionLayout",
    components: {
        Wordmark,
        LadderFooter,
        VModal
    },
    props: {
        page: { type: Object, required: true },
        mode: { default: "attribution-brand" }
    },
    data() {
        return {
            valueProp: 0,
            showLegalModal: false
        };
    },
    mounted() {
        // Save the offer in the shared store
        if (this.page.offers && this.page.offers.length) {
            store.setOffer(this.page.offers[0]);
        }

        anime
            .timeline()
            .add({
                targets: "#fade",
                opacity: [0, 0.72],
                translateZ: [0],
                scale: [1.2, 1],
                duration: 600,
                delay: 200,
                easing: "easeOutQuad"
            })
            .add({
                targets: "#hero",
                opacity: [0, 1],
                translateZ: [0],
                translateY: [-20, 0],
                duration: 600,
                delay: anime.stagger(200),
                easing: "easeOutQuad"
            })
            .add(
                {
                    targets: "#carousel",
                    opacity: [0, 1],
                    translateZ: [0],
                    translateX: [20, 0],
                    duration: 600,
                    easing: "easeOutQuad"
                },
                "-=200"
            )
            .add(
                {
                    targets: "#phone",
                    opacity: [0, 1],
                    translateZ: [0],
                    translateX: [-20, 0],
                    duration: 600,
                    easing: "easeOutQuad"
                },
                "-=600"
            );
    },
    methods: {
        contactSupport() {
            require("@/services/Intercom.js");
            window.Intercom("show");
        }
    }
};
</script>

<style scoped lang="scss">
$light: #eefafa;
$light-faded: transparentize($light, 0.85);

.bg-image {
    background-size: cover;
    box-shadow: inset 0 10rem 15rem rgba(0, 0, 0, 0.6);
    background-attachment: fixed;
    background-color: $dark;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: $dark;
    opacity: 0.72;
}

#header {
    position: fixed;
    height: 3.5rem;
    line-height: 3.5rem;
    top: 0px;
    left: 0px;
    width: 100%;
    background-color: $dark;
    z-index: 10;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14);
    color: $light;

    i {
        opacity: 0.48;
        font-size: 14px;
    }
    .header-image {
        height: 24px;
    }
}

.attribution-club #header {
    background-color: transparentize($primary, 0.44);
    text-align: center;
    height: 2.5rem;
    line-height: 2.5rem;
    font-size: 14px;
}

#fade {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: $dark;
    opacity: 0.72;
}

#hero {
    min-height: 100vh;
    position: relative;
    z-index: 3;

    #logo {
        font-size: 2.5rem;
        margin: 0px;
        margin-bottom: 3rem;
    }

    .hero-content {
        text-align: left;
        position: relative;
        z-index: 2;
        min-height: 100vh;
        width: 42.5rem;
        padding-top: 10.5rem;
        font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI",
            Roboto, Ubuntu;

        h1 {
            font-size: 2.5rem;
            letter-spacing: 4px;
            margin: 0px;
            margin-top: 1rem;
            font-weight: 900;
            color: $light;
            font-family: -apple-system, system-ui, BlinkMacSystemFont,
                "Segoe UI", Roboto, Ubuntu;

            img {
                max-height: 8rem;
            }
        }

        h4 {
            font-size: 1.5rem;
            letter-spacing: 2px;
            margin: 0px;
            font-weight: 900;
            color: $light;
            opacity: 0.64;
            font-family: -apple-system, system-ui, BlinkMacSystemFont,
                "Segoe UI", Roboto, Ubuntu;
        }
    }
}

#cta {
    width: 14rem;
    height: 4rem;
    border: 3px solid $primary;
    padding: 0.3rem;
    border-radius: 2rem;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.24);
    transition: all 300ms ease;
    margin-top: 2rem;

    a {
        font-size: 1rem;
        display: block;
        text-align: center;
        line-height: 3.1rem;
        width: 100%;
        height: 100%;
        border-radius: 2rem;
        background-color: $primary;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
        transition: all 300ms ease;
        text-decoration: none;

        &:hover {
            background-color: darken($primary, 5%);
        }
    }

    &:hover {
        border-color: darken($primary, 5%);
    }
}

#value-props {
    margin-top: 5rem;
    #phone {
        margin-right: 3rem;
        position: relative;

        img {
            position: relative;
            z-index: 3;
            width: 14rem;
            min-height: 435px;
        }
    }

    #carousel {
        .tabs {
            width: 100%;
            height: 6rem;
            background-color: $light-faded;
            border-radius: 1rem;
            padding: 0.5rem;
            display: grid;
            width: 100%;
            grid-gap: 0.5rem;
            grid-template-columns: 1fr 1fr 1fr;

            > div {
                color: #fff;
                line-height: 12px;
                font-size: 14px;
                border-radius: 0.5rem;
                padding: 0.5rem;
                transition: all 300ms ease;
                cursor: pointer;

                &.selected,
                &:hover {
                    background-color: $light;
                    color: $dark;

                    img:first-child {
                        display: none;
                    }

                    img:not(:first-child) {
                        display: inline;
                    }
                }
            }

            img {
                width: 20px;
                height: 20px;

                &:not(:first-child) {
                    display: none;
                }
            }
        }

        .value {
            p {
                font-weight: 300;
                font-size: 18px;
                margin-top: 1.5rem;
                margin-bottom: 1.5rem;
            }

            h4 {
                font-family: "Druk";
                letter-spacing: 2px;
                opacity: 1;
                color: $light;
                margin: 0px;
                margin-top: 0px;
                line-height: 2.375rem;
                font-size: 2rem;
                font-weight: 900;
                opacity: 0.8;

                &:first-of-type {
                    opacity: 0.4;
                }
            }
        }
    }
}

.footer-buttons .btn {
    width: 2rem;
    height: 2rem;
    padding: 0px !important;
    line-height: 2rem;
    text-align: center;
    border-radius: 50% !important;
}

@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    #hero {
        min-height: 120vh;

        .hero-content {
            width: 100%;
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: 8rem;

            #logo {
                font-size: 2rem;
            }
        }

        #phone {
            display: none;
        }
    }

    #cta {
        width: 100%;
    }

    .value {
        max-width: 100vw;

        .mobile-screenshot {
            width: 36%;
            padding-top: 2rem;
        }

        img {
            width: 100%;
        }
    }
}
</style>
